import CityPagePersianas from "../components/CityPagePersianas";

export default function PersianasAntequera() {
  return (
    <CityPagePersianas
      name="Antequera"
      slug="antequera"
      cp="29200"
      poblacion={41000}
      zonaGeo="Antequera y Norte"
      lat={37.0181}
      lng={-4.5594}
      zonas={[
        "Centro Antequera",
        "El Romeral",
        "La Estación",
        "Bobadilla",
      ]}
      landmarks={[
        "Alcazaba",
        "Dólmenes de Antequera (UNESCO)",
        "El Torcal",
        "Real Colegiata",
      ]}
      municipiosLimitrofes={[
        "Mollina",
        "Humilladero",
        "Casabermeja",
        "Archidona",
        "Campillos",
      ]}
      festivalLocal="Real Feria de Agosto, finales de agosto"
      contextoTipologico="Ciudad monumental interior, casco histórico con persianas tradicionales, clima continental con extremos térmicos."
      isCoreZone={false}
    />
  );
}